var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17V10C1 7.23858 3.23858 5 6 5L11.5 5",
    stroke: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1L12 5L8.5 8.5",
    stroke: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedJob);
export default __webpack_public_path__ + "static/media/completedJob.e6882817c688760d566341d79161f694.svg";
export { ForwardRef as ReactComponent };